import {
  ArobaseIcon,
  DlIcon,
  QuestionIcon,
  LogoutIcon,
  CogIcon,
  AnalyticsIcon,
  NoteIcon,
  PeopleIcon,
  MailIcon,
  PlugIcon,
  BillingIcon,
  ChannelClosedIcon,
} from 'components/Utils/Icons'
import DesktopHelpers from 'helpers/DesktopHelpers'
import RoutesHelper from 'helpers/RoutesHelper'

export default function getBodyEntries({
  organization,
  user,
  desktopDownloadURL,
  canManage,
  canManageBilling,
  canInvite,
  joinedOrganizations,
  getRootURL,
  getOtherOrganizationAppURL,
  openImportModal,
  signOut,
  goToOrganizationUpgrade,
  hasSimpleAnalytics,
  currentUserIsGuest,
}) {
  return (
    [
      // User settings
      {
        type: 'header',
        photoURL: user.photoURL,
        title: user.displayName,
        subtitle: `@${user.username}`,
      },
      {
        type: 'item',
        title: 'Personal settings',
        icon: ArobaseIcon,
        to: RoutesHelper.settingsProfile(),
      },
      {
        type: 'item',
        title: 'Download the app',
        icon: DlIcon,
        isAllowed: desktopDownloadURL && !DesktopHelpers.isAppDesktop(),
        action: () => {
          window.open(desktopDownloadURL, '_blank')
        },
      },
      {
        type: 'item',
        title: 'Help',
        icon: QuestionIcon,
        action: () => {
          window.Intercom
            ? window.Intercom('show')
            : window.open('mailto:contact@slite.com')
        },
      },
      { type: 'divider' },
      {
        type: 'header',
        photoURL: organization.photoURL,
        title: organization.name,
        subtitle: `${
          organization.domain // Organization settings
        }.slite.com`,
        withAction: {
          title: 'Logout',
          icon: LogoutIcon,
          tooltip: `Log out from ${organization.domain}`,
          action: () => {
            signOut()
          },
        },
      },
      {
        type: 'item',
        title: 'Import',
        icon: DlIcon,
        action: () => {
          openImportModal()
        },
      },
      {
        type: 'item',
        title: 'Team settings',
        icon: CogIcon,
        isAllowed: organization.product === 'free' || canManage,
        to: RoutesHelper.settingsOrganizationIndex(),
      },
      {
        type: 'item',
        title: 'Team insights',
        icon: AnalyticsIcon,
        isAllowed: !currentUserIsGuest && hasSimpleAnalytics,
        to: RoutesHelper.settingsAnalytics(),
      },
      {
        type: 'note-usage',
        title: 'notes used',
        icon: NoteIcon,
        action: () => {
          goToOrganizationUpgrade({ incentiveId: 'NotesLimit' })
        },
      },
      {
        type: 'item',
        title: 'Show members',
        icon: PeopleIcon,
        isAllowed: !currentUserIsGuest && !canManage,
        to: RoutesHelper.settingsUsers(),
      },
      {
        type: 'item',
        title: 'Member management',
        icon: PeopleIcon,
        isAllowed: canManage,
        to: RoutesHelper.settingsUsers(),
      },
      {
        type: 'item',
        title: 'Invitations',
        icon: MailIcon,
        isAllowed: canInvite,
        to: RoutesHelper.settingsInvitations(),
      },
      {
        type: 'item',
        title: organization.product === 'free' ? 'Upgrade' : 'Billing',
        icon: BillingIcon,
        isAllowed: organization.product === 'free' || canManageBilling,
        to: RoutesHelper.settingsOrganizationBilling(),
      },
      {
        type: 'item',
        title: 'Channel  management',
        icon: ChannelClosedIcon,
        isAllowed: canManage,
        to: RoutesHelper.settingsOrganizationChannels(),
      },
      {
        type: 'item',
        title: 'Integrations',
        icon: PlugIcon,
        isAllowed: !currentUserIsGuest,
        to: RoutesHelper.settingsIntegrations(),
      },
    ]
      // Joined organizations
      .concat(
        joinedOrganizations.size === 0
          ? []
          : { type: 'divider', title: 'Other teams' }
      )
      .concat(
        joinedOrganizations.toArray().map(organization => ({
          type: 'item',
          title: `Switch to ${organization.name}`,
          subtitle: `${organization.domain}.slite.com`,
          avatar: organization.photoURL,
          avatarName: organization.name,
          action: () => {
            window.location = getOtherOrganizationAppURL(organization.domain)
          },
        }))
      )
      .concat([
        {
          type: 'divider',
        },
        {
          type: 'button',
          title: 'Sign in to another team',
          action: () => {
            window.location = `${getRootURL()}/organization/select`
          },
        },
      ])
  )
}
